import type { CSSProperties } from "react";
import type { Theme } from "../../../providers/ThemeProvider";

type ChatResponseCssVariables = CSSProperties & Record<`--${string}`, string>;

export const getChatResponseCssVariables = (
  theme: Theme
): ChatResponseCssVariables => ({
  "--chat-thread-bg": theme.colors_ds.NEUTRAL_BG_ELEVATION1,
  "--chat-surface-main": theme.colors_ds.NEUTRAL_BG_MAIN,
  "--chat-surface-subtle": theme.colors_ds.NEUTRAL_BG_ELEVATION1,
  "--chat-surface-info": theme.colorTokens.P[10],
  "--chat-surface-selected": theme.colorTokens.P[10],
  "--chat-surface-success": theme.colorTokens.S[10],
  "--chat-surface-warning": theme.colorTokens.W[10],
  "--chat-surface-danger": theme.colorTokens.D[10],
  "--chat-border-default": theme.colors_ds.NEUTRAL_BORDER_WEAK,
  "--chat-border-strong": theme.colors_ds.NEUTRAL_BORDER_DEFAULT,
  "--chat-border-selected": theme.colors_ds.PRIMARY_TEXT_MAIN,
  "--chat-border-graph": theme.colors_ds.NEUTRAL_BORDER_GRAPH,
  "--chat-text-strong": theme.colors_ds.NEUTRAL_TEXT_STRONG,
  "--chat-text-default": theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
  "--chat-text-weak": theme.colors_ds.NEUTRAL_TEXT_WEAK,
  "--chat-text-inverse": theme.colors_ds.NEUTRAL_GENERAL_WHITE,
  "--chat-text-primary": theme.colors_ds.PRIMARY_TEXT_MAIN,
  "--chat-text-success": theme.colorTokens.S[80],
  "--chat-text-warning": theme.colorTokens.W[80],
  "--chat-text-danger": theme.colorTokens.D[80],
  "--chat-text-primary-strong": theme.colorTokens.P[80],
  "--chat-user-bubble-bg": theme.colors_ds.PRIMARY_TEXT_MAIN,
  "--chat-user-bubble-bg-hover": theme.colorTokens.P[90],
  "--chat-selection-ring": `inset 0 0 0 1px ${theme.colors_ds.PRIMARY_TEXT_MAIN}`,
  "--chat-shadow": "var(--box-shadow-general)",
});

export const getChatTooltipStyle = (theme: Theme): CSSProperties => ({
  borderRadius: "8px",
  border: `1px solid ${theme.colors_ds.NEUTRAL_BORDER_WEAK}`,
  backgroundColor: theme.colors_ds.NEUTRAL_BG_MAIN,
  boxShadow: "var(--box-shadow-general)",
  color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
  fontFamily: "var(--font-Regular)",
  fontSize: "12px",
});
